import { LoadingSkeleton } from 'sonata-react-components';

import './visitationMetricTrendsSkeleton.scss';

const COLUMN_COUNT = 9;
const ROW_COUNT = 10;
const DAY_CELL_COUNT = 7;

export default function VisitationMetricTrendsSkeleton() {
  return (
    <div className="visitationMetricTrendsSkeleton">
      {/* Header bar */}
      <div className="visitationMetricTrendsSkeleton__header">
        <LoadingSkeleton height={48} width="100%" />
      </div>

      <div className="visitationMetricTrendsSkeleton__body">
        {/* Heatmap block */}
        <div className="visitationMetricTrendsSkeleton__heatmap">
          {/* Column header row */}
          <div className="visitationMetricTrendsSkeleton__heatmapHeaderRow">
            {Array.from({ length: COLUMN_COUNT }).map((_, i) => (
              <LoadingSkeleton height={32} key={i} width="100%" />
            ))}
          </div>

          {/* Store data rows */}
          {Array.from({ length: ROW_COUNT }).map((_, rowIndex) => (
            <div className="visitationMetricTrendsSkeleton__heatmapRow" key={rowIndex}>
              {/* Rank cell */}
              <div className="visitationMetricTrendsSkeleton__rankCell">
                <LoadingSkeleton height={16} width={100} />
                <LoadingSkeleton height={14} width="80%" />
              </div>

              {/* Day metric cells */}
              {Array.from({ length: DAY_CELL_COUNT }).map((_, dayIndex) => (
                <LoadingSkeleton height={48} key={dayIndex} width="100%" />
              ))}

              {/* Average cell */}
              <LoadingSkeleton height={48} width="100%" />
            </div>
          ))}
        </div>

        {/* Controls row: week nav + slider */}
        <div className="visitationMetricTrendsSkeleton__controls">
          <div className="visitationMetricTrendsSkeleton__weekNav">
            <LoadingSkeleton height={28} width={28} />
            <LoadingSkeleton height={20} width={120} />
            <LoadingSkeleton height={28} width={28} />
          </div>
          <div className="visitationMetricTrendsSkeleton__slider">
            <LoadingSkeleton height={32} width="100%" />
          </div>
        </div>
      </div>
    </div>
  );
}
